import { BaseResponse } from '@/types/common';
import axiosInstance from './axiosInstance';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

/**
 * 上传提示词
 * @param file 上传的文件
 */
export const uploadPrompt = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const resp = await axiosInstance.post<BaseResponse<string>>(
    `${baseUrl}/robot/importData`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return resp.data;
};
